import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-950 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="mb-12">
          {/* Legal */}
          <div className="max-w-xs">
            <h3 className="text-white font-bold text-lg mb-6">LEGAL</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-cyan-400 transition-colors">
                  Terms and Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            {/* Logo */}
            <div className="flex items-center gap-4">
              <img src="/logo-bgremoved.png" alt="NEXXO FUNDED" className="h-12" />
              <div className="text-right">
                <div className="text-gray-400 text-sm">©2025 NEXXO FUNDED</div>
              </div>
            </div>

            {/* Legal Text */}
            <div className="flex-1 max-w-4xl">
              <div className="space-y-4 text-xs text-gray-500 leading-relaxed">
                <div>
                  <strong className="text-gray-400">Legal Disclaimer:</strong><br />
                  Nexxo Funded is a trading name of Nexxo Global Ltd, registered in England & Wales (Company No. 16474384). Registered office: 52 Grosvenor Gardens, London, England, SW1W 0AU. We are a proprietary trading firm, not a broker, and do not offer CFDs, brokerage services, or access to live markets. All programs operate in simulated environments for educational purposes only. Fees are program access subscriptions and are not client deposits or investments. Nexxo Funded does not accept participants from the United States, Canada, Cyprus, Iran, North Korea, Sudan, Syria, Russia, or any other jurisdiction where such services would be unlawful. Trading involves risk, and results in simulated accounts do not guarantee future performance in live markets.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
